import axios from 'axios';
export default {
  name: 'accountTypes',
  data () {
    return {
      accountTypesList: [],
      route: '/settings/accountTypes/edit/',
    };
  },
  methods: {
    addAccountType () {
      this.$router.push(this.route);
    },
    editAccType (accType) {
      this.$router.push(this.route + accType.ID);
    },
    removeAccType (accType) {
      axios.post(this.$store.getters.rootAPI + '/permissions/removeAccountType', accType).then((response) => {
        if (response.data > 0) {
          this.accountTypesList.forEach((item, index) => {
            if (item.ID == response.data) {
              this.accountTypesList.splice(index, 1);
            }
          });
        }
      });
    },
    deactivateAccType (accType) {
      // console.log(accType);
    },
    getAllAccTypes () {
      axios.get(this.$store.getters.rootAPI + '/permissions/getAccountTypes').then((response) => {
        if (response.status == 200) {
          this.accountTypesList = response.data;
        }
      });
    },
  },
  created () {
    this.getAllAccTypes();
  },
};
